export default __webpack_public_path__ + "static/media/NIAS0400.34I-29076_-16911_0.2d26577d.jpg";